import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Button } from 'react-admin';
import { usePhoneCalls } from '../../../../contexts/PhoneCallsContext/PhoneCallsContext';
import './dialpad.css';

interface DialPadProps {
  onNumberPress: (digit: string) => void;
}

export const DialPad: React.FC<DialPadProps> = ({ onNumberPress }) => {
  const dialPadButtons = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'];
  const [pressedKey, setPressedKey] = useState<string | null>(null);

  const { activeCallState } = usePhoneCalls();

  // Add visual feedback for keyboard presses
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const key = event.key;
      if ((key >= '0' && key <= '9') || key === '*' || key === '#') {
        setPressedKey(key);
      }
    };

    const handleKeyUp = () => {
      setPressedKey(null);
    };

    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup', handleKeyUp);
    };
  }, []);

  return (
    <Box
      className='dial-box'
      display='flex'
      flexDirection='column'
      alignItems='center'
      width='100%'>
      {!activeCallState.call && (
        <Typography
          variant='body1'
          sx={{
            color: '#9e9e9e',
            mb: 2,
            height: '30px',
            display: 'flex',
            alignItems: 'center',
            textAlign: 'center',
          }}>
          Type a number or search a patient to start
        </Typography>
      )}

      <Box display='grid' gridTemplateColumns='repeat(3, 1fr)' gap={2} sx={{ width: '280px' }}>
        {dialPadButtons.map((digit) => (
          <Button
            key={digit}
            onClick={() => onNumberPress(digit)}
            className={`dial-button ${pressedKey === digit ? 'pressed' : ''}`}>
            <Typography variant='h5' sx={{ fontWeight: 400 }}>
              {digit}
            </Typography>
          </Button>
        ))}
      </Box>
    </Box>
  );
};
